import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { apiGet } from 'services';

export const OAuthHubsport = ({ location, history }) => {
    const guid = useSelector(state => state.user.user.guid);

    const values = queryString.parse(location.search);
    if (values.code) {
        apiGet(
            `hubspot-accesscode/${values.code}`,
            guid,
            () => {
                history.replace('/admin/integrations');
            },
            null,
            true
        );
    }

    return 'Loading Hubspot API Details...';
};

export default withRouter(OAuthHubsport);
